import { useMutation, useQueryClient } from '@tanstack/react-query';
import { clientService } from '@services/client';
import { toast } from 'react-toastify';
import { getErrorMessage } from '@utils/errorMessage';
import { useTranslation } from '@hooks/useTranslation';
import { CLIENT_QUERY_KEY } from './useClient';
import { CLIENTS_QUERY_KEY } from './useClients';

// Sprint 25, story-128 (run 5). Backs Flow C (resend) and Flow D (invite from the "No client
// login" state, and the "Replace login" half of a change-email confirmation).
export const useInviteClientUser = () => {
  const tActionMessages = useTranslation('actionMessages');
  const queryClient = useQueryClient();
  const tClients = useTranslation('clients');

  return useMutation({
    mutationKey: ['inviteClientUser'],
    mutationFn: async ({
      clientId,
      resend,
    }: {
      clientId: string;
      resend?: boolean;
    }) => clientService.inviteClientUser(clientId, resend),
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: CLIENT_QUERY_KEY(variables.clientId) });
      queryClient.invalidateQueries({ queryKey: CLIENTS_QUERY_KEY });
      toast.success(
        variables.resend
          ? tClients['inviteResent'] || tActionMessages.invitationResent
          : tClients['createdInvited']?.replace('{email}', data.email || '') ||
              tActionMessages.invitationSent,
      );
    },
    onError: (error: any) => {
      toast.error(getErrorMessage(error, tActionMessages.requestError));
    },
  });
};

export default useInviteClientUser;
